import WidgetSearchEventRequestModel from '../../generated/types/model/resource/WidgetSearchEventRequestModel';

export default class WidgetSearchEventRequestViewModel extends WidgetSearchEventRequestModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
